module.exports = __webpack_public_path__ + "img/high-water-tank.d8a71080.jpg";